export default __webpack_public_path__ + "static/media/intro-image-2.606eba19.png";